import React from 'react';
import './StatsModal.css';
import { medalMap } from './utils';

const StatsModal = ({ open, onClose, stats }) => {
    const [view, setView] = React.useState('total');
    if (!open) return null;

    const activeStats = stats[view] || stats.total;
    const { played, winPct, currentStreak, maxStreak, medals, history } = activeStats;

    return (
        <div className="stats-modal-overlay" onClick={onClose}>
            <div className="stats-modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose} aria-label="Close">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                        width="24"
                        fill="currentColor"
                    >
                        <path d="M0 0h24v24H0V0z" fill="none" />
                        <path d="M18.3 5.71a1 1 0 00-1.41 0L12 10.59 7.11 5.7A1 1 0 105.7 7.11L10.59 12l-4.89 4.89a1 1 0 101.41 1.41L12 13.41l4.89 4.89a1 1 0 001.41-1.41L13.41 12l4.89-4.89a1 1 0 000-1.4z" />
                    </svg>
                </button>

                <div className="stats-header">
                    <h2>Statistics</h2>
                    <div className="segmented-control">
                        <button
                            className={view === 'total' ? 'active' : ''}
                            onClick={() => setView('total')}
                        >
                            Total
                        </button>
                        <button
                            className={view === 'hard' ? 'active' : ''}
                            onClick={() => setView('hard')}
                        >
                            Hard
                        </button>
                    </div>
                </div>

                <div className="stats-grid">
                    <div className="stat-card">
                        <span className="stat-value">{played}</span>
                        <span className="stat-label">Played</span>
                    </div>
                    <div className="stat-card">
                        <span className="stat-value">{winPct}</span>
                        <span className="stat-label">Win %</span>
                    </div>
                    <div className="stat-card">
                        <span className="stat-value">{currentStreak}</span>
                        <span className="stat-label">Current Streak</span>
                    </div>
                    <div className="stat-card">
                        <span className="stat-value">{maxStreak}</span>
                        <span className="stat-label">Max Streak</span>
                    </div>
                </div>

                <div className="dist-container medals-summary">
                    <div className="medals-header">
                        <h3>Medal Count</h3>
                    </div>
                    <div className="medals-table">
                        <div className="medals-table-header">
                            <span className="col-label">Medal</span>
                            <span className="col-label">Total</span>
                            <span className="col-label">Streak</span>
                            <span className="col-label">Max</span>
                        </div>
                        <div className="medal-row">
                            <span className="medal-type">🥇 Gold</span>
                            <span className="medal-val">{medals.gold.count}</span>
                            <span className="medal-val">{medals.gold.currentStreak}</span>
                            <span className="medal-val">{medals.gold.maxStreak}</span>
                        </div>
                        <div className="medal-row">
                            <span className="medal-type">🥈 Silver</span>
                            <span className="medal-val">{medals.silver.count}</span>
                            <span className="medal-val">{medals.silver.currentStreak}</span>
                            <span className="medal-val">{medals.silver.maxStreak}</span>
                        </div>
                        <div className="medal-row">
                            <span className="medal-type">🥉 Bronze</span>
                            <span className="medal-val">{medals.bronze.count}</span>
                            <span className="medal-val">{medals.bronze.currentStreak}</span>
                            <span className="medal-val">{medals.bronze.maxStreak}</span>
                        </div>
                    </div>
                </div>

                <div className="history-container">
                    <h3>Recent History</h3>
                    <ul className="history-list">
                        {history.length === 0 ? (
                            <li className="history-empty">No games recorded</li>
                        ) : (
                            history.map((game, i) => {
                                const date = new Date(game.timestamp).toLocaleDateString(undefined, {
                                    month: 'short',
                                    day: 'numeric'
                                });

                                const levelsCompleted = (game.levels || []).filter(l => l.completed).length;
                                const gameMedals = (game.levels || [])
                                    .filter(l => l.completed)
                                    .map((_, idx) => medalMap[idx])
                                    .reverse()
                                    .join(' ');

                                let statusText = 'SCRATCH';
                                let statusClass = 'status-scratch';

                                if (levelsCompleted === 3) { statusText = 'CRACKED'; statusClass = 'status-gold'; }
                                else if (levelsCompleted === 2) { statusText = 'SILVER'; statusClass = 'status-silver'; }
                                else if (levelsCompleted === 1) { statusText = 'BRONZE'; statusClass = 'status-bronze'; }

                                return (
                                    <li key={i} className="history-item">
                                        <span className="history-date">{date}</span>
                                        <span className="history-medals">{gameMedals}</span>
                                        <span className={`history-status ${statusClass}`}>
                                            {statusText}
                                        </span>
                                    </li>
                                );
                            })
                        )}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default StatsModal;
